export { default } from './DetailedCarGallery';
